import { useAtomValue } from "jotai";

import { BulkUpdateRequest } from "api/data";

import {
  changedCellsAtom,
  columnsAtom,
  fieldGroupDataAtom,
  uwisAtom
} from "../atoms/fieldGroupAtoms";
import {
  getChangedCellsFromMap,
  getNewColumnCells
} from "../atoms/utils/cellTransformers";

/**
 * Hook to get all changed cells (edited cells + new column cells) for bulk update.
 */
export function useGetChangedCells(): BulkUpdateRequest["updates"] {
  const changedCells = useAtomValue(changedCellsAtom);
  const columns = useAtomValue(columnsAtom);
  const uwis = useAtomValue(uwisAtom);
  const initialData = useAtomValue(fieldGroupDataAtom);

  const editedCells = getChangedCellsFromMap(changedCells);
  const newColumnCells = initialData
    ? getNewColumnCells(columns, uwis, initialData.columns)
    : [];

  return [...editedCells, ...newColumnCells];
}
